import script from "./CrowdfundingBlindenzorglichtliefde.vue?vue&type=script&setup=true&lang=js"
export * from "./CrowdfundingBlindenzorglichtliefde.vue?vue&type=script&setup=true&lang=js"

import "./CrowdfundingBlindenzorglichtliefde.vue?vue&type=style&index=0&id=77b7eab2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b7eab2"]])

export default __exports__